// extracted by mini-css-extract-plugin
export default {"logo":"style_logo__MXX9p","title":"style_title__wDKPP"};